
import * as bie from "react-bootstrap";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import md5 from "md5";
import { useState } from "react";
import { failureAlert, successAlert2 } from "./CommonUtils/SweetAlerts";
import { config } from "./CommonUtils/CommonURLS";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function ForgotPassword() {
  const [instStatus, setInstStatus] = useState(false);
  const [instName, setInstName] = useState("");
  const [isChecking, setIsChecking] = useState(false);
  let navigate = useNavigate();
  const goHome = () => {
    navigate("/"); // Navigate to home page
  };
  const forgotFormik = useFormik({
    initialValues: {
      institutionCode: "",
      newpassword: "",
      confirmpassword: "",
    },

    validationSchema: Yup.object({
      newpassword: Yup.string()
        .required("Enter New Password")
        .min(8, "Password must be at least 8 characters")
        .matches(/[0-9]/, "Must contain at least one number")
        .matches(/[a-zA-Z]/, "Must contain at least one alphabet")
        .matches(/[@$!%*?&]/, "Must contain at least one special character")
        .matches(/[A-Z]/, "Must contain at least one uppercase letter")
        .matches(/[a-z]/, "Must contain at least one lowercase letter"),

      confirmpassword: Yup.string()
        .required("Please confirm your password")
        .oneOf([Yup.ref("newpassword")], "Passwords must match"),
    }),

    onSubmit: (val) => {
      const payload = {
        aiesheCode: val.institutionCode,
        newPassword: md5(val.newpassword),
        confirmPassword: md5(val.confirmpassword),
      };

      Swal.fire({
        text: "Are you sure you want to reset the password?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Reset Password",
        cancelButtonText: "Cancel",
        backdrop: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const url = config.url.FAC_URL + "forgetPassword";
          axios.post(url, payload).then((res) => {
            if (res?.data?.scode === "01") {
              successAlert2(res?.data?.sdesc || "Password reset successfully");
              setInstStatus(false);
              setInstName("");
              goHome();




            } else {
              failureAlert(res?.data?.sdesc || "Failed to reset password");
            }
          });
        }
      });
    },
  });

  const GetInstData = (id) => {
    if (!id) return;

    setIsChecking(true);
    setInstStatus(false);
    setInstName("");

    const url = `${config.url.FAC_URL}getInstituteDtls?userId=${id}`;

    axios
      .get(url)
      .then((res) => {
        if (res.data.status === true && res.data.scode === "01") {
          const name = res.data.data?.[0]?.user_name || "Institution Found";
          setInstName(name);
          setInstStatus(true);
        } else {
          failureAlert("Institution not found. Please try a different code.");
          forgotFormik.setFieldValue("institutionCode", "");
          forgotFormik.setFieldValue("newpassword", "");
          forgotFormik.setFieldValue("confirmpassword", "");
          setInstStatus(false);
          setInstName("");
        }
      })
      .catch(() => {
        failureAlert("Something went wrong. Please try again.");
        setInstStatus(false);
        setInstName("");
      })
      .finally(() => {
        setIsChecking(false);
      });
  };

  return (
    <>
      <header className="top-header top-headerfoot">
        <div className="par-logopart">
          <img src="../images/ap-logo.webp" alt="" className="img-fluid" />

          <div className="paralogo-text">
            {/* <p className="mb-0">State Project Directorate</p>
                    <p className="mb-0">Rashtriya Uchchatar Shiksha Abhiyan (RUSA)</p> */}
            <h4 className="mb-0">
              Higher Education Department </h4>
            <p className="mb-0"> Government of Andhra Pradesh</p>
          </div>
        </div>
      </header>
      <bie.Container>

        <div className="forgot-wrapper">
          <div >
            <h5 className="innerheader-new"><span>Forgot</span> Password</h5>
          </div>
          <div className="forgot-card">
            <FormikProvider value={forgotFormik}>
              <Form
                autoComplete="off"
                onSubmit={forgotFormik.handleSubmit}
                className="form_adjust  faculty-form"
              >
                <bie.Row className="px-2 pt-3 mb-3">

                  {/* Step 1: Institution Code */}
                  <bie.Row className="mb-3">
                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                      <label className="field-mandatory">User Id:</label>
                      <Field
                        type="text"
                        name="institutionCode"
                        className="form-control"
                        placeholder="Enter User ID"
                        autoComplete="off"
                        maxLength={15}
                        // onBlur={(e) => {
                        //   forgotFormik.handleBlur(e);
                        //   const val = e.target.value.trim();
                        //   if (val) {
                        //     GetInstData(val);
                        //   } else {
                        //     setInstStatus(false);
                        //     setInstName("");
                        //   }
                        // }}
                        // onChange={(e) => {
                        //   forgotFormik.handleChange(e);
                        //   if (!e.target.value) {
                        //     setInstStatus(false);
                        //     setInstName("");
                        //   }
                        // }}
                        onBlur={forgotFormik.handleBlur}
                        onChange={(e) => {
                          forgotFormik.handleChange(e);

                          if (!e.target.value) {
                            setInstStatus(false);
                            setInstName("");
                          }
                        }}
                      />
                      <ErrorMessage
                        name="institutionCode"
                        component="div"
                        className="text-danger"
                      />
                      {isChecking && (
                        <small className="text-muted">Verifying institution...</small>
                      )}
                    </bie.Col>
                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                      {!instStatus && (<>
                        <div className="getdet-btn">
                          <button
                            type="button"
                            className="btn submit-btn btn-sm rounded"
                            disabled={forgotFormik.isSubmitting}
                            onClick={() => {
                              const val = forgotFormik.values.institutionCode?.trim();

                              if (val) {
                                GetInstData(val);
                              } else {
                                setInstStatus(false);
                                setInstName("");
                              }
                            }}
                          >
                            Get Data
                          </button>
                        </div>
                      </>)}
                    </bie.Col>

                  </bie.Row>

                  {/* Step 2: Institution Name Banner + Password Fields */}
                  {instStatus && (
                    <>
                      {/* Institution Name Display */}
                      <bie.Row className="mb-3">
                        <bie.Col xs={12} sm={12} md={12} lg={7} xl={7} xxl={7}>
                          <div
                            className="alert alert-success d-flex align-items-center py-2 px-3"
                            role="alert"
                            style={{ borderRadius: "6px" }}
                          >
                            <i className="bi bi-building me-2"></i>
                            <span>
                              <strong> Institution Name:</strong> {instName}
                            </span>
                          </div>
                        </bie.Col>


                      </bie.Row>

                      <bie.Row className="mb-2 faculty-form">
                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                          <label className="field-mandatory">New Password :</label>
                          <Field
                            type="password"
                            name="newpassword"
                            className="form-control"
                            placeholder="Enter New Password"
                            autoComplete="new-password"
                          />
                          <ErrorMessage
                            name="newpassword"
                            component="div"
                            className="text-danger"
                          />
                        </bie.Col>
                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                          <label className="field-mandatory">Confirm Password :</label>
                          <Field
                            type="password"
                            name="confirmpassword"
                            className="form-control"
                            placeholder="Confirm New Password"
                            autoComplete="new-password"
                          />
                          <ErrorMessage
                            name="confirmpassword"
                            component="div"
                            className="text-danger"
                          />
                        </bie.Col>
                        <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                          {instStatus && (
                            <div className="getdet-btn">
                              <button
                                type="submit"
                                className="btn submit-btn btn-sm rounded"
                                disabled={forgotFormik.isSubmitting}
                              >
                                Reset Password
                              </button>
                            </div>
                          )}
                        </bie.Col>
                      </bie.Row>
                    </>
                  )}


                </bie.Row>
              </Form>
            </FormikProvider>
          </div>
        </div>
      </bie.Container>
      <footer className='forgot-footer' >
        <p className='mb-0'>Design and Developed by <a href='https://apcfss.in/' target='_blank'>
          <img src='../images/footer-logo.svg' alt='' className='img-fluid' />
        </a>
        </p>
      </footer>

    </>
  );
}